import { render, staticRenderFns } from "./BrowseImage.vue?vue&type=template&id=3143dbe9&scoped=true&"
import script from "./BrowseImage.vue?vue&type=script&lang=js&"
export * from "./BrowseImage.vue?vue&type=script&lang=js&"
import style0 from "./BrowseImage.vue?vue&type=style&index=0&id=3143dbe9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143dbe9",
  null
  
)

export default component.exports